module.exports = __webpack_public_path__ + "static/media/vaporeon.d7e58c41.jpg";